import ko from 'knockout';
import _ from 'lodash';
import BaseDialog from '../base-dialog';
import template from 'raw-loader!./stale-preferences-dialog.html';

    

    var instance = null;

    function StalePreferencesDialog() {
        if (instance !== null) {
            throw new Error('Cannot instantiate more than one StalePreferencesDialog. Call StalePreferencesDialog.getInstance().');
        }
    }

    function StalePreferencesDialogVM() {
        var self = this;

        self.saveChoice = ko.observable();
        self.saveChoiceMade = ko.pureComputed(function() {
            return !_.isNil(self.saveChoice());
        });
    }

    StalePreferencesDialogVM.prototype = {
        proceed: function() {
            var self = this;
            self.modal.close(self.saveChoice() === "override");
        }
    };

    StalePreferencesDialog.prototype = {
        showModal: function() {
            return BaseDialog.showModal({
                viewModel: new StalePreferencesDialogVM(),
                template: template,
                context: this
            });
        }
    };

    StalePreferencesDialog.getInstance = function() {
        if (instance === null) {
            instance = new StalePreferencesDialog();
        }
        return instance;
    };

    export default StalePreferencesDialog.getInstance();
